import {IUserAccess} from '../../../features/user-access/models/user-access';

export function hasAccessToRule(accessNumber: number, ruleNumber: number): boolean {
  // Calculate the power of 2 for the given rule number
  const rulePower = 1 << ruleNumber;

  // Use bitwise AND to check if the accessNumber includes this rule
  return (accessNumber & rulePower) !== 0;
}

/**
 * Matches GallixRules `userIsStoreAdmin` for the selected store.
 * Store settings under `stores/{storeId}/settings/**` require this for the selected store.
 */
export function isStoreAdminForStore(
  userAccess: IUserAccess | null | undefined,
  storeId: string | null | undefined,
): boolean {
  if (!userAccess || !storeId) {
    return false;
  }
  return (userAccess.adminAccessStores ?? []).includes(storeId);
}
